import { lazy } from "react";
import Loadable from "./components/Loadable";
import RequireAuth from "./components/RequireAuth";
import Login from "./pages/Login";

const Notice = Loadable(lazy(() => import(/* webpackChunkName: "main-notice" */ "./pages/main/Notice.tsx")));

const Vendor = Loadable(lazy(() => import(/* webpackChunkName: "admin-vendor" */ "./pages/admin/Vendor")));
const User = Loadable(lazy(() => import(/* webpackChunkName: "admin-user" */ "./pages/admin/User")));
const ItemCode = Loadable(lazy(() => import(/* webpackChunkName: "admin-itemcode" */ "./pages/admin/ItemCode.js")));

const WorkAreaCode = Loadable(lazy(() => import(/* webpackChunkName: "admin-workAreaCode" */ "./pages/admin/WorkAreaCode")));
const InspectItem = Loadable(lazy(() => import(/* webpackChunkName: "admin-inspectItem" */ "./pages/admin/InspectItem.js")));
const ItemCodePerVendor = Loadable(lazy(() => import(/* webpackChunkName: "admin-itemCodePerVendor" */ "./pages/admin/ItemCodePerVendor.js")));

const TrendChart = Loadable(lazy(() => import(/* webpackChunkName: "admin-trandChart" */ "./pages/qc/TrendChart")));
const IQCResult = Loadable(lazy(() => import(/* webpackChunkName: "qc-iqcResult" */ "./pages/qc/IQCResult.js")));
const IQCList = Loadable(lazy(() => import(/* webpackChunkName: "qc-iqcList" */ "./pages/qc/IQCList.js")));
const OQCResult = Loadable(lazy(() => import(/* webpackChunkName: "qc-oqcResult" */ "./pages/qc/OQCResult.js")));
const OQCList = Loadable(lazy(() => import(/* webpackChunkName: "qc-oqcList" */ "./pages/qc/OQCList.js")));
const InspReport = Loadable(lazy(() => import(/* webpackChunkName: "qc-inspReport" */ "./pages/qc/InspReport.tsx")));
//...

// const IQC_Detail = Loadable(lazy(() => import('./pages/IQC_Detail')));
// const PQC_Result = Loadable(lazy(() => import('./pages/qc/PQC_Result')));
// const PQC_List = Loadable(lazy(() => import('./pages/qc/PQC_List')));
// const PQC_Detail = Loadable(lazy(() => import('./pages/PQC_Detail')));
// const OQC_Detail = Loadable(lazy(() => import('./pages/OQC_Detail')));

const CertMgmt = Loadable(lazy(() => import(/* webpackChunkName: "management-certMgmt" */ "./pages/management/CertMgmt.tsx")));
const AuditStatus = Loadable(lazy(() => import(/* webpackChunkName: "management-auditEvaluation" */ "./pages/management/AuditEvaluation.tsx")));
const CorrectiveAction = Loadable(lazy(() => import(/* webpackChunkName: "management-correctiveAction" */ "./pages/management/CorrectiveAction.tsx")));
const PcnMgmt = Loadable(lazy(() => import(/* webpackChunkName: "management-pcnMgmt" */ "./pages/management/PcnMgmt.tsx")));
const NcrMgmt = Loadable(lazy(() => import(/* webpackChunkName: "management-ncrMgmt" */ "./pages/management/NcrMgmt.tsx")));

export const pageRoutes = [
    { path: "notice", element: <Notice /> },

    { path: "itemCode", element: <ItemCode /> },
    { path: "user", element: <User /> },
    { path: "vendor", element: <Vendor /> },
    { path: "itemCodePerVendor", element: <ItemCodePerVendor /> },
    { path: "workAreaCode", element: <WorkAreaCode /> },
    { path: "inspectItem", element: <InspectItem /> },

    { path: "trendChart", element: <TrendChart /> },
    { path: "iqc", element: <IQCResult /> },
    { path: "iqclist", element: <IQCList /> },
    { path: "oqc", element: <OQCResult /> },
    { path: "oqclist", element: <OQCList /> },
    { path: "inspReport", element: <InspReport /> },
    // { path: 'iqc_list/:qrCode', element: <IQC_Detail /> },
    // { path: 'pqc', element: <PQC_Result /> },
    // { path: 'pqc_list', element: <PQC_List /> },
    // { path: 'pqc_list/:qrCode', element: <PQC_Detail /> },
    // { path: 'oqc_list/:qrCode', element: <OQC_Detail /> },

    { path: "certMgmt", element: <CertMgmt /> },
    { path: "auditStatus", element: <AuditStatus /> },
    { path: "correctiveAction", element: <CorrectiveAction /> },
    { path: "PcnMgmt", element: <PcnMgmt /> },
    { path: "ncrMgmt", element: <NcrMgmt /> },
];

const routes = [
    { path: "login", element: <Login /> },
    {
        path: "/",
        element: <RequireAuth />,
        children: pageRoutes,
    },
];

export default routes;
